export default __webpack_public_path__ + "static/media/blob_04.f6f120c9.mp4";